import isNumber from './is-number';
var isEven = function (num) {
    return isNumber(num) && num % 2 === 0;
};
export default isEven;
//# sourceMappingURL=is-even.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-even.js
// module id = 492
// module chunks = 3